/**
 * Use in array.filter() operations to remove undefined or null values
 * in a way that the compiler will understand
 */
function filterEmptyValues<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export default filterEmptyValues;
